import { ComponentPropsWithRef, forwardRef } from 'react';
import {
  Select as MUISelect,
  SelectProps as MUISelectProps,
} from '@mui/material';

export type SelectProps = ComponentPropsWithRef<typeof Select>;

export const Select = forwardRef<HTMLSelectElement, MUISelectProps>(
  function Select(props, ref) {
    return <MUISelect ref={ref} {...props} />;
  },
);
